var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 192,
    viewBox: "0 0 193 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.365 160H16.3652V89.7832L56.3652 64.7832V84.7832L88.3652 64.7832V84.7832L120.365 64.7832V88H124.785L132.785 16H159.945L167.945 88H176.365V160ZM24.3652 152H168.365V96H160.785L152.785 24H139.945L131.945 96H112.365V79.2168L80.3652 99.2168V79.2168L48.3652 99.2168V79.2168L24.3652 94.2168V152ZM68.3652 112H36.3652V120H68.3652V112ZM112.365 112H80.3652V120H112.365V112ZM156.365 112H124.365V120H156.365V112Z",
    fill: "#C0C0C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.585b781bbdc271ed123b1e0d16ca3a4b.svg";
export { ForwardRef as ReactComponent };